module.exports = __webpack_public_path__ + "static/img/SearchDetailEnterprise2.abae455.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailEnterprise2.png
// module id = 726
// module chunks = 0